import {Dropdown, IDropdownOption, IDropdownStyles} from '@fluentui/react';
import React from "react";

const CustomScript = ({onUpdate, disabled, customScript}) => {

    const onChange = (e,v) => {
        onUpdate("customScriptAllowed", v.key === 'yes')
    }

    const options: IDropdownOption[] = [
        { key: 'yes', text: 'Yes' },
        { key: 'no', text: 'No' }
    ];

    const dropdownStyles: Partial<IDropdownStyles> = {
        dropdown: { width: 70 }
    };

    return (
        <div style={{width:'100%', position:'relative'}}>
            <span> Custom Script: </span>
            <div className="dropdown">
            <Dropdown
                onChange={onChange.bind(this)}
                disabled={disabled}
                defaultSelectedKey={customScript ? 'yes' : 'no'}
                options={options}
                styles={dropdownStyles}
                />
            </div>
        </div>
    );
}

export default CustomScript


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/CustomScript.js